import React from 'react';
import { isNullOrUndefined, isNull } from 'util';

export default class NumberInput extends React.Component {
    constructor(args) {
        super(args);
        
        this.state = this.createState(this.props);
    }

    componentWillReceiveProps(newProps) {
        let state = this.createState(newProps);
        this.setState(state);
    }

    createState(props) {
        let decimals = props.decimals ? parseInt(props.decimals) : null;
        decimals = isNaN(decimals) ? null : decimals;

        let min = props.min ? parseFloat(props.min) : null;
        min = isNaN(min) ? null : min;

        let max = props.max ? parseFloat(props.max) : null;
        max = isNaN(max) ? null : max;

        return {
            value: isNullOrUndefined(props.value) ? "" : props.value,
            decimals: decimals,
            min: min,
            max: max
        };
    }

    clearValue(value, decimals = null, min = null, max = null, isFinal = false) {
        if (isNullOrUndefined(value)) {
            return "";
        } else {
            // Приводим к строке, если это не строка
            let stringValue = typeof value === 'string' ? value : String(value);
            // Заменяем запятую на точку для корректного парсинга
            let normalizedValue = stringValue.replace(',', '.');
            let numValue = parseFloat(normalizedValue);
            if (isNaN(numValue)) {
                return "";
            } else {
                if (!isNull(min) && numValue < min) {
                    return "" + min;
                }
                if (!isNull(max) && numValue > max) {
                    return "" + max;
                }
                if (!isNull(decimals)) {
                    let dotPos = normalizedValue.indexOf('.');
                    if (dotPos >= 0) {
                        let correctValue = normalizedValue.slice(0, dotPos + decimals + 1);
                        if (decimals < 1) {
                            if (isFinal) {
                                correctValue = correctValue.slice(0, -1);
                            } else {
                                correctValue = correctValue + '0';
                            }
                        }
                        return correctValue;
                    }
                }
                return normalizedValue;
            }
        }
    }

    saveValue(value) {
        this.setState({ value: value });
        let fieldValue = value === "" ? null : value;
        if (this.props.onChange) {
            this.props.onChange(fieldValue);
        }
    }

    handleInputValueChanged(e) {
        let value = this.clearValue(e.target.value, this.state.decimals, this.state.min, this.state.max);
        this.saveValue(value);
    }

    handleInputBlur() {
        let value = this.clearValue(this.state.value, this.state.decimals, this.state.min, this.state.max, true);
        this.saveValue(value);
        if (this.props.onEditComplete) {
            this.props.onEditComplete();
        }
    }

    handleInputKeyDown(e) {
        if (e.keyCode === 13) {
            this.handleInputBlur();
        }
    }

    render() {
        return (
            <input type="number"
                className={"form-control " + (this.props.className ? this.props.className : "")+ (this.props.error ? ' error' : '')}
                id={this.props.id}
                step={this.props.step || 1}
                title={this.props.title}
                value={this.state.value}
                min={this.state.min}
                max={this.state.max}
                onChange={e => this.handleInputValueChanged(e)}
                onBlur={() => this.handleInputBlur()}
                onKeyDown={e => this.handleInputKeyDown(e)}
                disabled={this.props.disabled}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./App/controls/numberInput.jsx